import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Edition = makeShortcode("Edition");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Edition name="paas" mdxType="Edition" />
    <h3 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h3>
    <ul>
      <li parentName="ul">{`Adobe Commerce on cloud infrastructure or on-premises: 2.4.5+`}</li>
      <li parentName="ul">{`PHP 8.1+`}</li>
      <li parentName="ul">{`Magento Open Source is not supported.`}</li>
    </ul>
    <h3 {...{
      "id": "installation"
    }}>{`Installation`}</h3>
    <p>{`To install custom attributes in Adobe Commerce:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Run the following command to install the modules:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`composer require magento/out-of-process-custom-attributes=^0.2.0  --with-dependencies
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enable the new module:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`bin/magento module:enable Magento_OutOfProcessCustomAttributes
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`For on-premises installations, run the following command to upgrade Adobe Commerce and clear the cache.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`bin/magento setup:upgrade && bin/magento cache:clean
`}</code></pre>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      